
import { ChatCitation } from '../../../../domain/messages/models/ChatCitation';
import { AuthorRoles, ChatMessage } from '../../../../domain/messages/models/ChatMessage';
import { NexusMessageDto } from '../dtos/responses/NexusMessageDto';
import { NexusSendMessageResponseCitationDto } from '../dtos/responses/NexusSendMessageResponseDto';


const toTimestamp = (value: string | number): number => {
    if (typeof value === 'number') {
        return value;
    }

    const timestamp = new Date(value).getTime();
    return Number.isNaN(timestamp) ? 0 : timestamp;
};

const mapRoleToAuthorRole = (role: string): AuthorRoles => {
    switch (role.toLowerCase()) {
        case 'assistant':
            return AuthorRoles.Bot;
        case 'user':
            return AuthorRoles.User;
        case 'system':
            return AuthorRoles.System
        default:
            return AuthorRoles.User;
    }
};

export const mapToChatCitation = (citations: NexusSendMessageResponseCitationDto[]): ChatCitation[] => {
    var formattedCitations: ChatCitation[] = [];
    if (!citations || citations.length == 0) return []
    citations.forEach(citation => {
        var formattedCitation: ChatCitation = { link: citation.url, title: citation.title ?? '' }
        formattedCitations.push(formattedCitation);
    });
    return formattedCitations;
}

export const mapNexusMessageDtoToModel = (dto: NexusMessageDto, chatId: string, nexusBaseUrl?: string): ChatMessage => ({
    id: dto.id,
    chatId: dto.conversationId ?? chatId,
    userName: dto.authorName ?? '',
    content: dto.content ?? dto.text ?? '',
    citations: mapToChatCitation(dto.citations) ?? [],
    timestamp: toTimestamp(dto.timestamp),
    type: 0, // default to message type (no document messages used by Nexus)
    authorRole: mapRoleToAuthorRole(dto.role),
    images: dto.images?.map(path =>
        nexusBaseUrl
            ? new URL(`conversations/${chatId}/images/${path.replaceAll('/', '_')}`, nexusBaseUrl).toString()
            : `/conversations/${chatId}/images/${path.replaceAll('/', '_')}`
    ),
});
